import React from 'react';
import styled from 'styled-components';
import MySampleChapterList, {LinkButton} from './mySampleChapterList';

const Header = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--br-space-3);
  justify-content: space-between;
  margin-bottom: var(--br-space-3);
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--br-space-2);
`;

const SampleChaptersTab = () => (
  <section>
    <Header>
      <p>
        Publish only the first chapter of a book — text, audio, or both — and
        let readers tell you whether they would keep reading. Use variants
        (A/B) to test alternative openings.
      </p>
      <Actions>
        <LinkButton to='/sample-chapters/discover'>Browse</LinkButton>
        <LinkButton to='/sample-chapters/new' variant='primary'>New sample</LinkButton>
      </Actions>
    </Header>
    <MySampleChapterList />
  </section>
);

export default SampleChaptersTab;
